var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIssuesClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "-1 -1 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#6FCF97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99896 11.8001L4.19896 9.00006L3.26562 9.9334L6.99896 13.6667L14.999 5.66673L14.0656 4.7334L6.99896 11.8001Z",
    fill: "#FCFCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssuesClosed);
export default __webpack_public_path__ + "static/media/issues_closed.6775428c.svg";
export { ForwardRef as ReactComponent };